export enum BadgeType {
  ERROR = 'error',
  PROGRESS = 'progress',
  SUCCESS = 'success',
  NEW = 'new',
  DISABLED = 'disabled',
}
